import sx from 'utils/createSx';

export default sx({
  root: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
});
